import React from "react";
import { Modal, Button } from "antd";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import "./RejectedDoctorModal.css";

/**
 * Popup bloquant affiché lorsque le statut du médecin est "rejected".
 * Affiche le motif de rejet (si fourni par l'admin) et un délai
 * indicatif de 10 jours pour corriger les informations.
 *
 * NOTE: le délai est actuellement une valeur statique d'affichage
 * (pas de vrai compte à rebours), en attendant qu'un champ de date
 * de rejet exploitable soit exposé par le backend (ms-doctor).
 */
export default function RejectedDoctorModal({
  open,
  onClose,
  rejectionReason,
  onGoToProfile,
}) {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const isRTL = (i18n.language || "").startsWith("ar");

  const handleGoToProfile = () => {
    if (typeof onGoToProfile === "function") {
      onGoToProfile();
    } else {
      navigate("/doctorprofile");
    }
    onClose?.();
  };

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      centered
      width={460}
      closable
      maskClosable={false}
      className="rejected-doctor-modal"
    >
      <div className="rejected-doctor-modal__content" dir={isRTL ? "rtl" : "ltr"}>
        <div className="rejected-doctor-modal__icon">
          <svg
            width="40"
            height="40"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <circle cx="12" cy="12" r="10" />
            <line x1="15" y1="9" x2="9" y2="15" />
            <line x1="9" y1="9" x2="15" y2="15" />
          </svg>
        </div>

        <h3 className="rejected-doctor-modal__title">
          {t("doctorStatus.rejectedModal.title", "Compte rejeté")}
        </h3>

        <p className="rejected-doctor-modal__text">
          {t(
            "doctorStatus.rejectedModal.intro",
            "Votre compte n'a pas pu être validé par notre équipe."
          )}
        </p>

        {rejectionReason && (
          <div className="rejected-doctor-modal__reason">
            <span className="rejected-doctor-modal__reason-label">
              {t("doctorStatus.rejectedModal.reasonLabel", "Motif :")}
            </span>
            <span className="rejected-doctor-modal__reason-text">
              {rejectionReason}
            </span>
          </div>
        )}

        <div className="rejected-doctor-modal__deadline">
          {t(
            "doctorStatus.rejectedModal.deadline",
            "Vous disposez d'un délai de 10 jours pour corriger vos informations, sans quoi l'accès à votre compte sera bloqué."
          )}
        </div>

        <Button
          type="primary"
          danger
          block
          size="large"
          onClick={handleGoToProfile}
          className="rejected-doctor-modal__btn"
        >
          {t(
            "doctorStatus.rejectedModal.cta",
            "Corriger mes informations"
          )}
        </Button>
      </div>
    </Modal>
  );
}